export enum CourseInstanceType {
  Assigned = 'assigned',
  Potential = 'potential',
}
